<template>
  <v-fab-transition>
    <sButton
      v-show="up_btn"
      class="up-btn"
      icon="long-arrow"
      icon-class="s-svg-icon-rotate-180"
      icon-size="12px"
      type="green"
      @click="click"/>
  </v-fab-transition>
</template>
<script>

export default {
  name: 'upBtn',
  data() {
    return {
      up_btn: false,
      element: null
    }
  },
  created() {
    this.$root.$on('enableUpBtn', this.enableUpBtn)
  },
  beforeDestroy() {
    this.$root.$off('enableUpBtn', this.disenableUpBtn)
    window.removeEventListener('scroll', this.scroll)
  },
  methods: {
    disenableUpBtn() {
      this.element?.removeEventListener('scroll', this.scroll, false)
    },
    enableUpBtn(selector) {
      this.element = document.querySelector(selector || '#components')
      this.element?.addEventListener('scroll', this.scroll, false)
    },
    scroll() {
      let condition = this.element?.scrollTop > this.element?.clientHeight
      if ( condition && !this.up_btn ) {
        this.showUpBtn()
      } else if ( !condition && this.up_btn ) {
        this.hideUpBtn()
      }
    },
    click() {
      this.element.scrollTop = 0
      this.hideUpBtn()
    },
    hideUpBtn() {
      this.up_btn = false
    },
    showUpBtn() {
      this.up_btn = true
    }
  },
  watch: {
    '$route'() {
      this.up_btn = false
    }
  }
}
</script>

<style lang="scss" scoped>

.up-btn {
  z-index: 1001;
  position: fixed;
  right: 16px;
  bottom: 16px;
  box-shadow: 0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)!important;
}

</style>
